<template>
<div class="case_new no-trans" v-loading="loading">
    <div class="r_top">
        <!-- <img src="@/assets/img/index/legal/r_top_bg.png" alt="" class="imgs"> -->
        <div class="titles">律师在线解答</div>
        <div class="text1">平均每5-10分钟获得律师快速解答</div>
        <div class="nums">123123123</div>
        <div class="text2">位用户已咨询</div>
        <div class="btns_box">
            <div class="btns" @click="$router.push('/lawyer_list')">快速咨询</div>
        </div>
    </div>
  
    <div class="r_bom" v-if="!mobile_view || $store.state.vuex_lawyers.length">
        <div class="banner_title">推荐律师</div>

        <div class="change_box">
            <div class="change_item" :class="{ 'change_item_ac': banner_ac == index }"
                v-for="(item, index) in $store.state.vuex_lawyers" :key="index"></div>
        </div>
        <el-carousel :autoplay="true" :indicator-position="'none'" @change="change_banner">
            <el-carousel-item v-for="(item, index) in $store.state.vuex_lawyers" :key="index">
                <div class="banner_box">
                    <div class="borders_box">
                        <div class="borders1"></div>
                        <div class="borders2">
                            <img :src="item.business_img" alt="">

                        </div>
                        <div class="tage_box" v-if="item.elite==1">
                            <div class="tages">金牌律师</div>
                        </div>
                    </div>
                    <div class="ls_name">{{item.name}}律师</div>
                    <div class="ls_texts">{{minx_get_causeIds(item.causeIds)}}</div>
                    <div class="btns_flex">
                        <div class="btns" @click="$router.push('/lawyer_detial?id='+item.id)">
                            <img src="@/assets/img/index/legal/icons1.png" alt="">

                            快速咨询
                        </div>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
    <div class="new_box">
        <div class="new_titles_btns">
            <div class="new_titles">精选问题</div>
            <div class="new_btns">
                更多
                <img src="../../assets/img/index/home/right1.png" alt="">
            </div>
        </div>
        <div class="nwe_lists">
            <div class="items" v-for="(item,index) in 8" :key="index">
                <div class="items_img" v-if="index<3">
                    <img src="@/assets/img/index/legal/title_bg.png" alt="">

                </div>
                <div class="item_icon" v-if="index>=3">{{ index+1 }}</div>
                <div class="items_info">
                    <div class="items_titles">
                        超市帮忙拿了几次钱又还给他了，他还不是不愿意
                        超市帮忙拿了几次钱又还给他了，他还不是不愿意
                    </div>                       
                    <div class="tages">
                        #财产分割
                        &nbsp;
                        2023.01.01
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import {
    mapState
} from 'vuex'



export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            banner_ac: 0,
            banner_list: [1, 2, 3]

        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    methods: {
        change_banner(e) {
            // console.log('却换触发',e)
            this.banner_ac = e
        },
    },

}
</script>
<style scoped lang="less">
.case_new {
    width: 420px;
    min-height: 100px;

    // background-color: red;
    .r_top {
        width: 420px;
        height: 300px;
        position: relative;
        padding: 32px 36px;
        // background-image: url("@/assets/img/index/legal/r_top_bg.png" );
        background-image: url('../../assets/img/index/legal/r_top_bg.png');
        background-size: 100%;

        // .imgs{
        //     width: 420px;
        //     height: 300px;
        //     position: absolute;
        //     left: 0;
        //     top: 0;
        // }
        .titles {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #333333;

        }

        .text1 {
            padding-top: 14px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #666666;

        }

        .nums {
            padding-top: 20px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 36px;
            color: #377CFD;

        }

        .text2 {

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #666666;

        }

        .btns_box {
            padding-top: 40px;

            .btns {
                width: 180px;
                height: 40px;
                background: #377CFD;
                box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
                border-radius: 4px 4px 4px 4px;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 14px;
                color: #FFFFFF;
            }
        }
    }
     

    .r_bom {
        width: 420px;
        height: 460px;
        // background: red;
        margin-top: 24px;
        position: relative;

        .banner_title {
            position: absolute;
            top: 24px;
            left: 32px;
            display: flex;
            align-items: center;
            z-index: 100;
            font-weight: bold;
            font-size: 18px;
            color: #FFFFFF;
        }

        .change_box {
            position: absolute;
            top: 32px;
            right: 32px;
            display: flex;
            align-items: center;
            z-index: 100;

            .change_item {
                width: 6px;
                height: 6px;
                background: #F2F2F5;
                border-radius: 50%;
                margin-left: 6px;
            }

            .change_item_ac {
                background: #377CFD;
            }
        }

        /deep/.el-carousel {
            width: 100%;
            height: 100%;

            .el-carousel__container {
                width: 100%;
                height: 100%;

                .banner_box {
                    width: 100%;
                    height: 100%;
                    background-image: url('../../assets/img/index/legal/banner_bg.png');
                    background-size: 100%;
                    padding-top: 88px;

                    .borders_box {
                        width: 160px;
                        height: 160px;
                        margin: auto;
                        border-radius: 50%;
                        // margin-top: 88px; 
                        // background: #FFFFFF;
                        // opacity: 0.2;
                        position: relative;

                        .borders1 {
                            width: 160px;
                            height: 160px;
                            background: #FFFFFF;
                            opacity: 0.2;
                            position: absolute;
                            left: 0;
                            top: 0;
                            z-index: 1;
                            border-radius: 50%;

                        }

                        .borders2 {
                            width: 132px;
                            height: 132px;
                            background: #C4C4C4;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            z-index: 2;
                            border-radius: 50%;

                            transform: translate(-50%, -50%);

                            img {
                                width: 132px;
                                height: 132px;
                                border-radius: 50%;

                            }
                        }

                        .tage_box {
                            width: 100%;
                            position: absolute;
                            z-index: 3;
                            bottom: -4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .tages {
                                cursor: pointer;
                                width: 104px;
                                height: 32px;
                                background: linear-gradient(180deg, #FAECC6 0%, #F2CF85 100%);
                                border-radius: 16px 16px 16px 16px;
                                border: 1px solid #876052;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #6C3E2D;
                                text-align: center;
                                line-height: 32px;
                            }
                        }

                    }

                    .ls_name {
                        padding-top: 28px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 24px;
                        color: #FFFFFF;
                        text-align: center;
                    }

                    .ls_texts {
                        padding-top: 14px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        text-align: center;
                    }

                    .btns_flex {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 40px;

                        .btns {
                            width: 180px;
                            height: 40px;
                            background: #377CFD;
                            box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
                            border-radius: 4px 4px 4px 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            line-height: 40px;
                            text-align: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;

                            img {
                                width: 14px;
                                height: 14px;
                                margin-right: 10px;
                            }
                        }
                    }
                }
            }

            .el-carousel__indicators {
                //  display: none;
            }
        }
    }
    .new_box{
        width: 416px;
        height: 613px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-top: 24px;
        padding: 24px;
        .new_titles_btns{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 20px;
            border-bottom: 1px solid #EEEEEE;
            .new_titles{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 18px;
                color: #333333;
            }
            .new_btns{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 12px;
                color: #377CFD;
                cursor: pointer;
                img{
                    width: 10px;
                }
            }
        }
        .nwe_lists{
            .items{
                display: flex;
                margin-top: 20px;
                cursor: pointer;
                .items_img{
                    width: 14px;
                    height: 18px;
                }
                .item_icon{
                    width: 18px;
                    height: 18px;
                    flex-shrink: 0;
                    border-radius: 50%;
                    background: rgba(55, 124, 253, 0.08);
                    // opacity: 0.08;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #666666;
                    text-align: center;
                    line-height: 18px;
                }
                .items_info{
                    padding-left: 14px;
                    .items_titles{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp:1;
                        -webkit-box-orient: vertical;
                     }
                     .tages{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 12px;
                        color: #999999;
                        padding-top: 10px;
                     }
                }
                &:hover{
                    .items_info{
                       .items_titles{
                            color:#377CFD ;
                       } 
                    }
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@import "../../styles/mobile-patterns.less";

@media (max-width: 1024px) {
    .case_new.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        width: 100%;
    }
    .case_new.no-trans .r_top {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        padding: 16px 16px;
    }
    .case_new.no-trans .r_top .titles {
        font-size: 24px;
    }
    .case_new.no-trans .r_top .text1 {
        padding-top: 14px;
        font-size: 14px;
    }
    .case_new.no-trans .r_top .nums {
        padding-top: 16px;
        font-size: 24px;
    }
    .case_new.no-trans .r_top .text2 {
        font-size: 14px;
    }
    .case_new.no-trans .r_top .btns_box {
        padding-top: 16px;
    }
    .case_new.no-trans .r_top .btns_box .btns {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_new.no-trans .r_bom {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        margin-top: 16px;
    }
    .case_new.no-trans .r_bom .banner_title {
        top: 16px;
        left: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 18px;
    }
    .case_new.no-trans .r_bom .change_box {
        top: 16px;
        right: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_new.no-trans .r_bom .change_box .change_item {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-left: 6px;
    }
    .case_new.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box {
        padding-top: 16px;
    }
    .case_new.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box {
        width: 160px;
        height: 160px;
        margin: auto;
        border-radius: 50%;
    }
    .case_new.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders1 {
        width: 160px;
        height: 160px;
        border-radius: 50%;
    }
    .case_new.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders2 {
        width: 132px;
        height: 132px;
        border-radius: 50%;
    }
    .case_new.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders2 img {
        width: 132px;
        height: 132px;
        border-radius: 50%;
    }
    .case_new.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .tage_box {
        bottom: -4px;
    }
    .case_new.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .tage_box .tages {
        width: 104px;
        height: 32px;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        line-height: 32px;
    }
    .case_new.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .ls_name {
        padding-top: 16px;
        font-size: 24px;
    }
    .case_new.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .ls_texts {
        padding-top: 14px;
        font-size: 14px;
    }
    .case_new.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex {
        padding-top: 16px;
    }
    .case_new.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex .btns {
        width: 180px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_new.no-trans .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex .btns img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
    .case_new.no-trans .new_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
        padding: 16px;
    }
    .case_new.no-trans .new_box .new_titles_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
    }
    .case_new.no-trans .new_box .new_titles_btns .new_titles {
        font-size: 18px;
    }
    .case_new.no-trans .new_box .new_titles_btns .new_btns {
        font-size: 14px;
    }
    .case_new.no-trans .new_box .new_titles_btns .new_btns img {
        width: 10px;
    }
    .case_new.no-trans .new_box .nwe_lists .items {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-top: 16px;
    }
    .case_new.no-trans .new_box .nwe_lists .items .items_img {
        width: 14px;
        height: 18px;
    }
    .case_new.no-trans .new_box .nwe_lists .items .item_icon {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        font-size: 14px;
        line-height: 18px;
    }
    .case_new.no-trans .new_box .nwe_lists .items .items_info {
        padding-left: 14px;
    }
    .case_new.no-trans .new_box .nwe_lists .items .items_info .items_titles {
        font-size: 14px;
    }
    .case_new.no-trans .new_box .nwe_lists .items .items_info .tages {
        font-size: 14px;
        padding-top: 10px;
    }
}

@media (max-width: 1024px) {
    .case_new.no-trans .r_bom { .mobile-lawyer-recommendation(); }
}
</style>
